// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"1fc6b241","612":"81ac8c4a","722":"6e9befc5","1470":"6e9befc5","1545":"81ac8c4a","4534":"81ac8c4a","4572":"6e9befc5","5478":"81ac8c4a","6152":"6e9befc5"}[chunkId] + ".chunk.css";
};